import Vue from 'vue'
import Router from 'vue-router'
import Core from '@/components/Core'
import System from '@/components/System'
import Master from '@/components/Master'
import Logs from '@/components/Logs'
import Tool from '@/components/Tool'
import BroadCast from '@/components/BroadCast'
// import LeadMaster from '@/components/Lead/Master'
import V2 from '@/components/V2'
import Reports from '../components/Reports'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/V2/ver2',
      name: 'ver2',
      component: V2.ver2
    },
    {
      path: '*',
      name: 'Login',
      component: Core.Login
    },
    {
      path: '/Master/Branch',
      name: 'Branch',
      component: Master.Branch
    },
    {
      path: '/Master/Color',
      name: 'Color',
      component: Master.Color
    },
    {
      path: '/Master/Card',
      name: 'Card',
      component: Master.Card
    },
    {
      path: '/Master/Level',
      name: 'Level',
      component: Master.Level
    },
    {
      path: '/Master/Reward',
      name: 'Reward',
      component: Master.Reward
    },
    {
      path: '/Master/ProductExchangeRate',
      name: 'ProductExchangeRate',
      component: Master.ProductExchangeRate
    },
    {
      path: '/system/fileupload',
      name: 'FileUpload',
      component: System.FileUpload
    },
    {
      path: '/system/Shop',
      name: 'Shop',
      component: System.Shop
    },
    {
      path: '/system/ListShop',
      name: 'ListShop',
      component: System.ListShop
    },
    {
      path: '/system/ListMember',
      name: 'ListMember',
      component: System.ListMember
    },
    {
      path: '/system/EditShop',
      name: 'EditShop',
      component: System.EditShop
    },
    {
      path: '/system/VgroupMapCoin',
      name: 'VgroupMapCoin',
      component: System.VgroupMapCoin
    },
    {
      path: '/system/ManageShop',
      name: 'ManageShop',
      component: System.ManageShop
    },
    {
      path: '/system/ListAllShop',
      name: 'ListAllShop',
      component: System.ListAllShop
    },
    {
      path: '/system/Errorpage',
      name: 'Errorpage',
      component: System.Errorpage
    },
    {
      path: '/Core/LoginFailed',
      name: 'LoginFailed',
      component: Core.LoginFailed
    },
    {
      path: '/Core/Login',
      name: 'Login',
      component: Core.Login
    },
    {
      path: '/Core/Home',
      name: 'Home',
      component: Core.Home
    },
    {
      path: '/Core/testHome',
      name: 'testHome',
      component: Core.testHome
    },
    {
      path: '/System/User',
      name: 'User',
      component: System.User
    },
    {
      path: '/System/UserTypeGroup',
      name: 'UserTypeGroup',
      component: System.UserTypeGroup
    },
    {
      path: '/System/Menu',
      name: 'Menu',
      component: System.Menu
    },
    {
      path: '/System/Privacy',
      name: 'Privacy',
      component: System.Privacy
    },
    {
      path: '/System/PrivacyCheck',
      name: 'PrivacyCheck',
      component: System.PrivacyCheck
    },
    {
      path: '/System/Running',
      name: 'Running',
      component: System.Running
    },
    {
      path: '/System/Token',
      name: 'Token',
      component: System.Token
    },
    {
      path: '/Logs/CRUD',
      name: 'CRUD',
      component: Logs.CRUD
    },
    {
      path: '/Logs/Auth',
      name: 'Auth',
      component: Logs.Auth
    },
    // {
    //   path: '/Tool/CollectQRCode',
    //   name: 'CollectQRCode',
    //   component: Tool.CollectQRCode
    // },
    {
      path: '/Tool/Refund',
      name: 'RefundPoint',
      component: Tool.RefundPoint
    },
    {
      path: '/Tool/CollectQRCodeLot',
      name: 'CollectQRCodeLot',
      component: Tool.CollectQRCodeLot
    },
    {
      path: '/Tool/RedeemQRCode',
      name: 'RedeemQRCode',
      component: Tool.RedeemQRCode
    },
    {
      path: '/Tool/Activity',
      name: 'Activity',
      component: Tool.Activity
    },
    {
      path: '/Master/Editv2',
      name: 'Editv2',
      component: Master.Editv2
    },
    {
      path: '/Core/ReportActivity',
      name: 'ReportActivity',
      component: Core.ReportActivityAVG
    },
    {
      path: '/Core/PackageMain',
      name: 'PackageMain',
      component: Core.PackageMain
    },
    {
      path: '/Core/VGroupShortcuts',
      name: 'VGroupShortcuts',
      component: Core.VGroupShortcuts
    },
    {
      path: '/Tool/ReportCode',
      name: 'ReportCode',
      component: Tool.ReportCode
    },
    {
      path: '/Tool/ReportCoin',
      name: 'ReportCoin',
      component: Tool.ReportCoin
    },
    {
      path: '/BroadCast/Audience',
      name: 'Audience',
      component: BroadCast.Audience
    },
    {
      path: '/BroadCast/BroadCast',
      name: 'BroadCast',
      component: BroadCast.BroadCast
    },
    {
      path: '/System/GivePoints',
      name: 'GivePoints',
      component: System.GivePoints
    },
    {
      path: '/Tool/GivePointM',
      name: 'GivePointM',
      component: Tool.GivePointM
    },
    {
      path: '/System/ManageApi',
      name: 'ManageApi',
      component: System.ManageApi
    },
    {
      path: '/Master/AddCoin',
      name: 'AddCoin',
      component: Master.AddCoin
    },
    {
      path: '/Master/Redeem',
      name: 'Redeem',
      component: Master.Redeem
    },
    {
      path: '/Master/Promotion',
      name: 'Promotion',
      component: Master.Promotion
    },
    {
      path: '/Master/Blog',
      name: 'Blog',
      component: Master.Blog
    },
    {
      path: '/Master/Package',
      name: 'Package',
      component: Master.Package
    },
    {
      path: '/Master/PackageQRcode',
      name: 'PackageQRcode',
      component: Master.PackageQRcode
    },
    {
      path: '/System/Transport',
      name: 'Transport',
      component: System.Transport
    },
    {
      path: '/Tool/VGroupShortcut',
      name: 'VGroupShortcut',
      component: Tool.VGroupShortcut
    },
    {
      path: '/System/Friendgetfriend',
      name: 'Friendgetfriend',
      component: System.Friendgetfriend
    },
    {
      path: '/System/pointFree',
      name: 'pointFree',
      component: System.pointFree
    },
    // {
    //   path: '/DashBroad',
    //   name: 'DashBroad',
    //   component: Master.DashBroad
    // },
    {
      path: '/ReportRedeemDonationPoints',
      name: 'ReportRedeemDonationPoints',
      component: Reports.ReportRedeemDonationPoints
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js